import { FORM_CONSTANTS } from "@/constants/form.constants";
import { Question } from "@/types/feedback.types";
import { getQuestionText } from "@/utils/formUtils";
import useFormLanguage from "@/utils/useFormLanguage.hook";
import { Controller, useFormContext } from "react-hook-form";
import { FormGroup, Input, Label } from "reactstrap";

const QuestionComment = (props: Question) => {
  const { id, required } = props;
  const formLanguageCode = useFormLanguage();
  const label = getQuestionText(props, formLanguageCode);

  const {
    control,
    formState: { errors },
  } = useFormContext();

  const fieldName = id.toString();

  return (
    <FormGroup
      data-cy="question-comment"
      noMargin
      className="d-flex flex-column align-items-start align-self-stretch gap-2 p-4 rounded-3 bg-white"
    >
      <Label
        for={fieldName}
        className="fs-6 fw-semibold text-break text-300 mb-2 "
        style={{
          textTransform: "none" as any,
        }}
      >
        {label}
        {required && <span className="text-danger d-none">&nbsp;*</span>}
      </Label>

      <Controller
        {...{ control }}
        name={fieldName}
        render={({ field }) => (
          <Input
            id={fieldName}
            type="textarea"
            value={field.value ?? ""}
            onChange={field.onChange}
            onBlur={field.onBlur}
            invalid={!!errors[fieldName]}
            maxLength={FORM_CONSTANTS.MAX_TEXT_LENGTH}
          />
        )}
      />
    </FormGroup>
  );
};

export default QuestionComment;
